import { message } from 'antd';
import { makeAutoObservable, runInAction } from 'mobx';
import APIs from '../../api/api';
import { User } from '../../types/user';
import { Operation } from '../../utils/Operation';
import { AppRootStore } from '../store';
import { debounce } from '../../helper/helper';

export default class FriendsStore {
    rootStore: AppRootStore;

    constructor(rootStore: AppRootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    getFriendsOperation = new Operation<User[]>([] as User[]);
    createFriendOperation = new Operation<{ friendId: number }>({} as { friendId: number });
    deleteFriendOperation = new Operation<{ friendId: number }>({} as { friendId: number });

    friends: User[] = [];

    usersListForAdd: User[] = [];
    usersListForAddEditGroup: User[] = [];
    collectUserList: number[] = [];

    loading: boolean = false;

    createUsername: User = {
        id: 0,
        blockedUsers: [],
    };

    getFriends = async () => {
        runInAction(() => {
            this.loading = true;
        });
        await this.getFriendsOperation.run(() => APIs.Friends.getfriends());
        if (this.getFriendsOperation.data) {
            runInAction(() => {
                this.friends = this.getFriendsOperation.data;
                this.usersListForAddEditGroup = this.friends.map(users => ({
                    ...users,
                    isAdded: this.rootStore.channelStore.channelUsers.some(e => e.id === users.id),
                }));
                this.usersListForAdd = this.friends.map(users => ({
                    ...users,
                    isAdded: false,
                }));
                console.log('gettt', this.usersListForAdd);
                this.loading = false;
            });
        }
    };

    setCollectUser = (id: number) => {
        if (!this.collectUserList.find(e => e === id)) {
            this.collectUserList.push(id);
            this.usersListForAdd = this.usersListForAdd.map(users => {
                if (users.id == id) {
                    return {
                        ...users,
                        isAdded: true,
                    };
                } else {
                    return {
                        ...users,
                        isAdded: users.isAdded,
                    };
                }
            });
            console.log('ssss', JSON.stringify(this.usersListForAdd));
        }
        this.rootStore.channelStore.setCreateChannelState('users', this.collectUserList);
    };

    getFriendsFilter = debounce((key: string) => {
        runInAction(() => {
            this.friends = this.getFriendsOperation.data.filter(i =>
                i.username?.trim().toLowerCase().includes(key.toLowerCase().trim()),
            );
        });
        if (!this.friends) {
            message.warning('No such username exists');
        }
    }, 1000);

    setSearchFriends = debounce((key: string) => {
        runInAction(() => {
            this.usersListForAdd = this.getFriendsOperation.data.filter(user =>
                user.username?.toLowerCase().includes(key.toLowerCase()),
            );
        });
    }, 1000);

    setSearchUsersForAdd = debounce((key: string) => {
        runInAction(() => {
            this.usersListForAdd = this.getFriendsOperation.data.filter(user =>
                user.username?.toLowerCase().includes(key.toLowerCase()),
            );
            this.usersListForAdd = this.usersListForAdd.map(users => ({
                ...users,
                isAdded: this.rootStore.channelStore.channelUsers.some(e => e.id === users.id),
            }));
            this.usersListForAddEditGroup = this.usersListForAdd.map(users => ({
                ...users,
                isAdded: this.rootStore.channelStore.channelUsers.some(e => e.id === users.id),
            }));
        });
    }, 1000);

    createFriend = async (friendId: number) => {
        await this.createFriendOperation.run(() => APIs.Friends.createFriend(friendId));
        if (this.createFriendOperation.data) {
            this.getFriends();
            runInAction(() => {
                this.rootStore.usersStore.nonFriends = this.rootStore.usersStore.nonFriends.filter(
                    e => e.id !== friendId,
                );
                this.rootStore.usersStore.filteredNonFriends = this.rootStore.usersStore.filteredNonFriends.filter(
                    e => e.id !== friendId,
                );
                this.getFriends();
                message.success(`Friend has been added successfully`);
                if (!!this.rootStore.channelStore.channelData.hashId) {
                    this.rootStore.channelStore.getChannelUsers(this.rootStore.channelStore.channelData.hashId);
                }
            });
        }
    };

    deleteFriend = async (friendId: number) => {
        await this.deleteFriendOperation.run(() => APIs.Friends.deleteFriend(friendId));
        if (this.deleteFriendOperation.isSuccess) {
            runInAction(() => {
                this.friends = this.friends.filter(e => e.id !== friendId);
                this.rootStore.usersStore.getNonFriends();
                message.success(`Friend has been deleted successfully`);
            });
            this.rootStore.channelStore.getChannelUsers(this.rootStore.channelStore.channelData.hashId);
        }
    };
}
